import { QueryClient } from '@tanstack/react-query';
import { queryClientConfig } from '@marqvision/shared/config/react-query';
import { http } from '~/apis/base';
import { Credits } from '~/swagger/Credits';
import { MonitoringEnforcementTp } from '~/swagger/MonitoringEnforcementTp';
import { MonitoringDetected } from '~/swagger/MonitoringDetected';
import { Home } from '~/swagger/Home';
import { MonitoringWebsiteContents } from '~/swagger/MonitoringWebsiteContents';
import { Performance } from '~/swagger/Performance';
import { IpPortfolio } from '~/swagger/IpPortfolio';
import { SellerAnalyticsDetail } from '~/swagger/SellerAnalyticsDetail';
import { LSettings } from '~/swagger/LSettings';
import { SellerAnalyticsDataDriven } from '~/swagger/SellerAnalyticsDataDriven';
import { Password } from '~/swagger/Password';
import { Email } from '~/swagger/Email';
import { Auth } from '~/swagger/Auth';
import { SellerAnalyticsCluster } from '~/swagger/SellerAnalyticsCluster';
import { SellerAnalyticsSeller } from '~/swagger/SellerAnalyticsSeller';
import { EmployeeSignup } from '~/swagger/EmployeeSignup';
import { InfringingImage } from '~/swagger/InfringingImage';
import { AuthorizedSeller } from '~/swagger/AuthorizedSeller';
import { SellerIntelligence } from '~/swagger/SellerIntelligence';
import { PerformanceDetailsEnfAnalysis } from '~/swagger/PerformanceDetailsEnfAnalysis';
import { PerformanceDetailsImpactedSellers } from '~/swagger/PerformanceDetailsImpactedSellers';
import { PerformanceDetailsCompRate } from '~/swagger/PerformanceDetailsCompRate';
import { Billing } from '~/swagger/Billing';
import { Map } from '~/swagger/Map';
import { MonitoringFilter } from '~/swagger/MonitoringFilter';
import { Settings } from '~/swagger/Settings';
import { AuthorizedWebsite } from '~/swagger/AuthorizedWebsite';
import { MonitoringWebsiteDomainNames } from '~/swagger/MonitoringWebsiteDomainNames';
import { OfficialImage } from '~/swagger/OfficialImage';
import { CustomTag } from '~/swagger/CustomTag';
import { PerformanceImpersonation } from '~/swagger/PerformanceImpersonation';
import { PerformancePiracy } from '~/swagger/PerformancePiracy';
import { PerformanceDetailsOffenderPiracy } from '~/swagger/PerformanceDetailsOffenderPiracy';
import { PerformanceDetailsCompRatePiracy } from '~/swagger/PerformanceDetailsCompRatePiracy';
import { AssetPiracy } from '~/swagger/AssetPiracy';
import { PerformanceDetailsEnfAnalysisPiracy } from '~/swagger/PerformanceDetailsEnfAnalysisPiracy';
import { AuthorizedSellerKeywordFiltering } from '~/swagger/AuthorizedSellerKeywordFiltering';
import { ConversationalAssistant } from '~/swagger/ConversationalAssistant';
import { WebsiteContentsPiracy } from '~/swagger/WebsiteContentsPiracy';
import { SocialMediaPiracy } from '~/swagger/SocialMediaPiracy';
import { HomePiracy } from '~/swagger/HomePiracy';

// Home
export const homeApi = new Home(http);
export const homePiracyApi = new HomePiracy(http);

// Performance
export const performanceApi = new Performance(http);
export const performancePiracyApi = new PerformancePiracy(http);
export const performanceDetailsOffenderPiracyApi = new PerformanceDetailsOffenderPiracy(http);
export const performanceDetailsCompRatePiracyApi = new PerformanceDetailsCompRatePiracy(http);
export const performanceDetailsEnfAnalysisPiracyApi = new PerformanceDetailsEnfAnalysisPiracy(http);
export const impersonationPerformanceApi = new PerformanceImpersonation(http);
export const performanceEnforcementApi = new PerformanceDetailsEnfAnalysis(http);
export const performanceSellerApi = new PerformanceDetailsImpactedSellers(http);
export const performanceComplianceRateApi = new PerformanceDetailsCompRate(http);

// Portfolio
export const portfolioApi = new IpPortfolio(http);
export const officialImageApi = new OfficialImage(http);
export const assetPiracyApi = new AssetPiracy(http);

export const authorizedSellerApi = new AuthorizedSeller(http);
export const authorizedSellerKeywordFilterApi = new AuthorizedSellerKeywordFiltering(http);
export const authorizedWebsiteAPI = new AuthorizedWebsite(http);

// Enforcements
export const monitoringEnforcementTpApi = new MonitoringEnforcementTp(http);
export const monitoringFilterApi = new MonitoringFilter(http);

// Monitoring Details

export const monitoringDetectedApi = new MonitoringDetected(http);

// Website Content
export const websiteContentApi = new MonitoringWebsiteContents(http);
export const websiteContentsPiracyApi = new WebsiteContentsPiracy(http);

// Social Media
export const socialMediaPiracyApi = new SocialMediaPiracy(http);

// Domain Names
export const domainNamesApi = new MonitoringWebsiteDomainNames(http);

// Domain Names
export const conversationalAssistantApi = new ConversationalAssistant(http);

// Seller
export const sellerAnalyticsClusterApi = new SellerAnalyticsCluster(http);
export const sellerAnalyticsDetailApi = new SellerAnalyticsDetail(http);
export const sellerAnalyticsSellerApi = new SellerAnalyticsSeller(http);
export const sellerIntelligenceApi = new SellerIntelligence(http);

export const sellerAnalyticsDetailDataDriven = new SellerAnalyticsDataDriven(http);

// Map Monitoring

export const mapMonitoringApi = new Map(http);

// Settings
export const legacySettingsApi = new LSettings(http);
export const settingsApi = new Settings(http);
export const creditsApi = new Credits(http);
export const billingApi = new Billing(http);
export const passwordApi = new Password(http);
export const emailApi = new Email(http);
export const authApi = new Auth(http);
export const employeeSignupApi = new EmployeeSignup(http);
export const infringingImageApi = new InfringingImage(http);
export const customTagApi = new CustomTag(http);

export const queryClient = new QueryClient(queryClientConfig);
